import { FlexBox } from '../../components/Base/FlexBox'
import { Dot } from '../../components/Dot/Dot'
import { Text } from '../../components/Text/Text'
import { useBreakpoint } from '../../hooks/useBreakpoint'
import { errorD1 } from '../../theme/colors'

export function SafetyDashboardNewViolationsLabel() {
  const isMobile = useBreakpoint('xs')
  return (
    <FlexBox alignItems="center" gap="5px" justifyContent="flex-end" mt={isMobile ? 0.2 : 0}>
      <Dot background={errorD1} />
      {isMobile ? null : (
        <Text variant="header4" fontColor={errorD1}>
          new violations
        </Text>
      )}
    </FlexBox>
  )
}
